<ion-content [scrollY]="true" [fullscreen]="true">
  <div class="min-h-screen bg-white relative overflow-hidden flex flex-col">

    <!-- Subtle Background Bubbles -->
    <div class="bubble bubble-1"></div>
    <div class="bubble bubble-2"></div>
    <div class="bubble bubble-3"></div>

    <!-- Content -->
    <div class="flex-1 flex flex-col items-start px-6 relative z-10"
      [style.padding-top]="isAndroid ? '4rem' : 'calc(env(safe-area-inset-top) + 4rem)'"
      [style.padding-bottom]="isAndroid ? '3rem' : 'calc(env(safe-area-inset-bottom) + 3rem)'">
      <div class="max-w-sm w-full mx-auto flex flex-col gap-8">

        <!-- Logo & Title -->
        <div class="flex flex-col items-center gap-4">
          <div class="p-3 border border-gray-200 rounded-full">
            <img src="assets/icon/app-icon-transparent.svg" alt="Logo" class="w-10 h-10" />
          </div>
          <h1 class="text-2xl font-semibold text-gray-900">
            {{ currentStep === 'email' ? 'Willkommen' : (isNewUser ? 'Konto erstellen' : 'Willkommen zurück') }}
          </h1>
          <p *ngIf="currentStep === 'email'" class="text-sm text-gray-500 text-center">
            Melde dich an oder erstelle ein Konto
          </p>
        </div>

        <!-- Social Logins (nur bei Email-Step) -->
        <div *ngIf="currentStep === 'email'" class="flex items-center gap-3 w-full">
          <button
            type="button"
            (click)="performGoogleLogin()"
            [disabled]="isGoogleLoginInitiated || isAppleLoginInitiated"
            class="flex-1 flex items-center justify-center py-2.5 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            <svg class="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
          </button>
          <button
            *ngIf="showAppleLogin"
            type="button"
            (click)="performAppleLogin()"
            [disabled]="isGoogleLoginInitiated || isAppleLoginInitiated"
            class="flex-1 flex items-center justify-center py-2.5 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
            </svg>
          </button>
        </div>

        <!-- Divider (nur bei Email-Step) -->
        <div *ngIf="currentStep === 'email'" class="flex items-center gap-3 w-full">
          <div class="h-px flex-1 bg-gray-200"></div>
          <span class="text-gray-500 text-sm font-medium">oder</span>
          <div class="h-px flex-1 bg-gray-200"></div>
        </div>

        <!-- ==================== STEP 1: EMAIL ==================== -->
        <form *ngIf="currentStep === 'email'" [formGroup]="emailForm" class="flex flex-col gap-5">
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-900">E-Mail</label>
            <input
              pInputText
              id="email_field"
              type="email"
              placeholder="name@email.de"
              formControlName="email"
              (keyup.enter)="checkEmail()"
              class="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-lg bg-white focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition-all"
            />
          </div>

          <button
            pButton
            type="button"
            (click)="checkEmail()"
            [disabled]="isCheckingEmail"
            [loading]="isCheckingEmail"
            class="w-full !py-2.5 !text-sm !font-medium !rounded-lg"
          >
            Weiter
          </button>
        </form>

        <!-- ==================== STEP 2: PASSWORD (Login oder Register) ==================== -->
        <form *ngIf="currentStep === 'password'" [formGroup]="passwordForm" class="flex flex-col gap-5">

          <!-- Email Display (readonly) -->
          <div class="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
            <div class="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i class="pi pi-user text-emerald-600 text-sm"></i>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium text-gray-900 truncate">{{ enteredEmail }}</p>
              <p class="text-xs text-gray-500">{{ isNewUser ? 'Neues Konto' : 'Bestehendes Konto' }}</p>
            </div>
            <button
              type="button"
              (click)="goBackToEmail()"
              class="text-emerald-600 text-sm font-medium hover:text-emerald-700"
            >
              Ändern
            </button>
          </div>

          <!-- Password -->
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-900">Passwort</label>
            <p-password
              id="password_field"
              (keyup.enter)="submitAuth()"
              formControlName="password"
              [placeholder]="isNewUser ? 'Mindestens 8 Zeichen' : 'Passwort eingeben'"
              [toggleMask]="true"
              styleClass="w-full"
              [fluid]="true"
              [feedback]="isNewUser"
              weakLabel="Schwach"
              mediumLabel="Mittel"
              strongLabel="Stark"
              promptLabel="Passwort eingeben"
              inputStyleClass="!w-full !px-3 !py-2.5 !text-sm !border !border-gray-200 !rounded-lg !bg-white focus:!border-emerald-500 focus:!ring-1 focus:!ring-emerald-500"
            >
            </p-password>
            <p *ngIf="isNewUser" class="text-xs text-gray-500">Verwende Groß-/Kleinbuchstaben, Zahlen und Sonderzeichen</p>
          </div>

          <!-- Forgot Password (nur bei Login) -->
          <div *ngIf="!isNewUser" class="flex justify-end">
            <button
              type="button"
              class="text-sm text-gray-500 hover:text-gray-700 transition-colors"
              (click)="openPasswordResetSheet()"
            >
              Passwort vergessen?
            </button>
          </div>

          <!-- Terms (nur bei Registration) -->
          <div *ngIf="isNewUser" class="flex items-start gap-2.5">
            <p-checkbox formControlName="toc" id="toc_field" binary class="mt-0.5"></p-checkbox>
            <label for="toc_field" class="text-sm text-gray-600 leading-relaxed">
              Ich akzeptiere die
              <a href="https://meinekommune.com/agbs" target="_blank" class="text-emerald-600 hover:underline">AGB</a>
              und
              <a href="https://meinekommune.com/datenschutz" target="_blank" class="text-emerald-600 hover:underline">Datenschutzerklärung</a>
            </label>
          </div>

          <!-- Submit Button -->
          <button
            pButton
            type="button"
            (click)="submitAuth()"
            [disabled]="isAuthInitiated"
            [loading]="isAuthInitiated"
            class="w-full !py-2.5 !text-sm !font-medium !rounded-lg"
          >
            {{ isNewUser ? 'Registrieren' : 'Anmelden' }}
          </button>

          <!-- Toggle zwischen Login und Registration -->
          <div class="text-center">
            <span class="text-sm text-gray-500">
              {{ isNewUser ? 'Bereits ein Konto?' : 'Noch kein Konto?' }}
            </span>
            <button
              type="button"
              (click)="toggleAuthMode()"
              class="text-sm text-emerald-600 font-medium hover:text-emerald-700 ml-1"
            >
              {{ isNewUser ? 'Anmelden' : 'Registrieren' }}
            </button>
          </div>

        </form>

      </div>
    </div>
  </div>

  <!-- Password Reset Bottom Sheet -->
  <ion-modal
    [isOpen]="isPasswordResetRequestVisible"
    [initialBreakpoint]="0.5"
    [breakpoints]="[0, 0.5, 0.75]"
    (didDismiss)="isPasswordResetRequestVisible = false"
  >
    <ng-template>
      <div class="px-6 py-8">
        <div class="flex flex-col items-center gap-4 mb-6">
          <div class="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center">
            <i class="pi pi-envelope text-xl text-emerald-600"></i>
          </div>
          <div class="text-center">
            <h3 class="text-lg font-semibold text-gray-900 mb-1">Passwort zurücksetzen</h3>
            <p class="text-sm text-gray-500">Wir senden dir einen Link per E-Mail</p>
          </div>
        </div>

        <form [formGroup]="passwordResetRequestForm" class="flex flex-col gap-4">
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-900">E-Mail</label>
            <input
              pInputText
              type="email"
              placeholder="name@email.de"
              formControlName="email"
              class="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-lg bg-white focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500"
            />
          </div>

          <button
            pButton
            type="button"
            (click)="performPasswordResetRequest()"
            [disabled]="isPasswordResetRequestInitiated"
            [loading]="isPasswordResetRequestInitiated"
            class="w-full !py-2.5 !text-sm !font-medium !rounded-lg mt-2"
          >
            Link senden
          </button>
        </form>
      </div>
    </ng-template>
  </ion-modal>

  <!-- Password Reset Form Modal -->
  <ion-modal
    [isOpen]="isPasswordResetVisible"
    [initialBreakpoint]="0.75"
    [breakpoints]="[0, 0.75, 1]"
    [backdropDismiss]="false"
  >
    <ng-template>
      <div class="px-6 py-8">
        <div class="flex flex-col items-center gap-4 mb-6">
          <div class="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center">
            <i class="pi pi-lock text-xl text-emerald-600"></i>
          </div>
          <div class="text-center">
            <h3 class="text-lg font-semibold text-gray-900 mb-1">Neues Passwort</h3>
            <p class="text-sm text-gray-500">Wähle ein sicheres Passwort</p>
          </div>
        </div>

        <form [formGroup]="passwordResetForm" class="flex flex-col gap-4">
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-900">Neues Passwort</label>
            <p-password
              formControlName="password"
              placeholder="Neues Passwort"
              [toggleMask]="true"
              [fluid]="true"
              autocomplete="off"
              styleClass="w-full"
              inputStyleClass="!w-full !px-3 !py-2.5 !text-sm !border !border-gray-200 !rounded-lg !bg-white"
            >
            </p-password>
          </div>

          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-900">Passwort bestätigen</label>
            <p-password
              formControlName="passwordConfirm"
              placeholder="Passwort wiederholen"
              [toggleMask]="true"
              (keyup.enter)="performPasswordReset()"
              [feedback]="false"
              [fluid]="true"
              autocomplete="off"
              styleClass="w-full"
              inputStyleClass="!w-full !px-3 !py-2.5 !text-sm !border !border-gray-200 !rounded-lg !bg-white"
            >
            </p-password>
          </div>

          <!-- Password Requirements -->
          <ul class="flex flex-col gap-1.5 text-xs mt-2">
            <li class="flex items-center gap-2">
              <i [ngClass]="hasUppercase(passwordResetForm.get('password')?.value) ? 'pi pi-check text-emerald-500' : 'pi pi-times text-gray-300'"></i>
              <span class="text-gray-600">Mindestens ein Großbuchstabe</span>
            </li>
            <li class="flex items-center gap-2">
              <i [ngClass]="hasLowercase(passwordResetForm.get('password')?.value) ? 'pi pi-check text-emerald-500' : 'pi pi-times text-gray-300'"></i>
              <span class="text-gray-600">Mindestens eine Zahl</span>
            </li>
            <li class="flex items-center gap-2">
              <i [ngClass]="hasMinLength(passwordResetForm.get('password')?.value, 8) ? 'pi pi-check text-emerald-500' : 'pi pi-times text-gray-300'"></i>
              <span class="text-gray-600">Mindestens 8 Zeichen</span>
            </li>
          </ul>

          <button
            pButton
            type="button"
            (click)="performPasswordReset()"
            [disabled]="isPasswordResetInitiated || passwordResetForm.invalid"
            [loading]="isPasswordResetInitiated"
            class="w-full !py-2.5 !text-sm !font-medium !rounded-lg mt-2"
          >
            Passwort ändern
          </button>
        </form>
      </div>
    </ng-template>
  </ion-modal>
</ion-content>
